import { createSlice } from "@reduxjs/toolkit";

export default createSlice({
    name: "growthAverageType",
    initialState: "ascentAverages",
    reducers: {
        setType: (state, action) => action.payload,
    },
});
